import React, { createContext, useState, useContext, useEffect, useCallback, useMemo } from 'react';

const CalendarContext = createContext();

export const useCalendar = () => useContext(CalendarContext);

export const CalendarProvider = ({ children }) => {
  const [isCalendarDetached, setIsCalendarDetached] = useState(() => {
    // Load calendar visibility state from localStorage
    return localStorage.getItem('calendarDetached') === 'true';
  });
  
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [calendarDate, setCalendarDate] = useState(new Date());
  
  // Toggle the calendar visibility
  const toggleCalendar = useCallback(() => {
    setIsCalendarDetached(prev => {
      const newState = !prev;
      // Save to localStorage
      localStorage.setItem('calendarDetached', newState.toString());
      return newState;
    });
  }, []);

  // Close the calendar
  const closeCalendar = useCallback(() => {
    setIsCalendarDetached(false);
    localStorage.setItem('calendarDetached', 'false');
  }, []);

  // Handle date changes
  const handleDateChange = useCallback((newDate) => {
    setCalendarDate(newDate);
    setSelectedDate(newDate);
  }, []);

  // Go to today
  const handleTodayClick = useCallback(() => {
    setCalendarDate(new Date());
    setSelectedDate(new Date());
  }, []);

  // Expose the calendar state and functions
  const value = useMemo(() => ({
    isCalendarDetached,
    selectedDate,
    calendarDate,
    toggleCalendar,
    closeCalendar,
    handleDateChange,
    handleTodayClick,
    setSelectedDate,
    setCalendarDate
  }), [isCalendarDetached, selectedDate, calendarDate, toggleCalendar, closeCalendar, handleDateChange, handleTodayClick]);

  return (
    <CalendarContext.Provider value={value}>
      {children}
    </CalendarContext.Provider>
  );
};

export default CalendarContext; 